import { Controller } from "@hotwired/stimulus"

// The picture on the Settings page: when a file is chosen it is shown at once
// in the monogram's place, cut to the same circle, so the member sees what
// Substance will keep before they save. Nothing is sent until the form is.
export default class extends Controller {
  static targets = ["frame", "input"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file || !file.type.startsWith("image/")) return

    if (this.url) URL.revokeObjectURL(this.url)
    this.url = URL.createObjectURL(file)

    const image = document.createElement("img")
    image.src = this.url
    image.alt = ""
    image.className = "monogram monogram-likeness rounded-full shrink-0 object-cover select-none size-20"
    this.frameTarget.replaceChildren(image)
  }

  // One of the drawn faces chosen: shown in the frame at once. The initials
  // option has no picture; the frame keeps what the page drew.
  pick(event) {
    const src = event.target.dataset.src
    if (!src) return

    const image = document.createElement("img")
    image.src = src
    image.alt = ""
    image.className = "monogram monogram-likeness rounded-full shrink-0 object-cover select-none size-20"
    this.frameTarget.replaceChildren(image)
  }

  disconnect() {
    if (this.url) URL.revokeObjectURL(this.url)
  }
}
